// extracted by mini-css-extract-plugin
module.exports =  {"root":"ztobxDn4Ci8D2zmfF0C3","icon":"TA6J8MdSPIUTaLmGhrqw","input":"u2JGWIGceFbcxurimQet","checkbox":"pv8zbDBBcGVXm79us7NG","placeholder":"xHXAmCZ7MqLluNRJEqCd"};